/* User defined models */
import { TestingAccommodation } from "./testingAccommodation.model";
import { SchedulingMode } from "../../constants/scheduling.constant";
import { Session } from "./session.model";


export class Exam {
  id: string;
  code: string;
  uri: string;
  name: string;
  proctorScheduling: boolean;
  nonProctorScheduling: boolean;
  schedule?: any;
  testing?: any;
  countries?: any;
  demographics?: any;
  startDate?: any;
  endDate?: any;
  duration?: any;
  isSelected?: boolean = false;
  status?: string;
  hasPayment?: boolean = false;
  testingAccommodations?: TestingAccommodation[];
  sessions?: Session[];
  examSet?: any;

  constructor(
    id: string,
    code: string,
    uri: string,
    name: string,
    nonProctorScheduling: boolean,
    proctorScheduling: boolean,
    startDate?: any,
    endDate?: any,
    isSelected?: boolean,
    duration?: any,
    sessions?: Session[],
    status?: string,
    testingAccommodations?: TestingAccommodation[],
    schedule?: any,
    testing?: any,
    countries?: any,
    demographics?: any,
    hasPayment?: boolean,
    examSet?: any
  ) {
    this.id = id;
    this.code = code;
    this.uri = uri;
    this.name = name;
    this.proctorScheduling = proctorScheduling;
    this.nonProctorScheduling = nonProctorScheduling;
    this.schedule = schedule;
    this.testing = testing;
    this.countries = countries;
    this.demographics = demographics;
    this.startDate = startDate;
    this.endDate = endDate;
    this.duration = duration;
    this.isSelected = isSelected;
    this.status = status;
    this.hasPayment = hasPayment;
    this.testingAccommodations = testingAccommodations;
    this.sessions = sessions;
    this.examSet = examSet;
  }

  setDatesFromArray(exams: Exam[]) {
    if (exams != null && exams != undefined && !!exams.length && exams[0].code != 'EligibilityError') {
      exams.filter((exam: Exam) => {
        if (this.id == exam.id) {
          this.startDate = exam.startDate;
          this.endDate = exam.endDate;
        }
      });
    }
  }

  static convertAPIObjectToExam(object: any, sessions?: Session[], status?: string, testingAccommodations?: TestingAccommodation[], hasPayment?: boolean, startDate?: any, endDate?: any): Exam {
    return new Exam(
      object.id,
      object.code,
      object.uri ||object.href,
      object.name,
      (object.deliveryMode === SchedulingMode.Both || object.deliveryMode === SchedulingMode.BrickAndMortar),
      (object.deliveryMode === SchedulingMode.Both || object.deliveryMode === SchedulingMode.Proctor),
      startDate || (!!object.testing && !!object.testing.startDate ? object.testing.startDate : null),
      endDate || (!!object.testing && !!object.testing.endDate ? object.testing.endDate : null),
      false,
      (!!object.schedule && !!object.schedule.duration ? object.schedule.duration : 0),
      sessions,
      status,
      testingAccommodations,
      object.schedule,
      object.testing,
      object.countries,
      object.demographics,
      hasPayment,
      object.examSet
      //object.sessions[0]
    );
  }
}